import { getInitialState, State } from "./state";

const initialState = getInitialState();

const reducer = (state: State = initialState): State => state;

export { reducer, getInitialState };
